import { motion, useReducedMotion } from "framer-motion";
import { BrandMark } from "@/components/BrandMark";

export function BatchCompletionMark({ justFinished }) {
  const reduceMotion = useReducedMotion();
  const play = justFinished && reduceMotion === false;
  return (
    <motion.div data-testid="batch-completion-mark" data-motion={play ? "upward" : "static"}
      aria-hidden="true" className="shrink-0 pt-1"
      initial={play ? { y: 20, opacity: 0 } : false}
      animate={{ y: 0, opacity: 1 }} transition={{ duration: play ? 0.5 : 0, ease: "easeOut" }}>
      <BrandMark testId="brand-mark-completion" className="h-10 w-10 sm:h-12 sm:w-12" />
    </motion.div>
  );
}
